/* HorecaBayim — TL / EUR / USD GÖRÜNTÜLEME katmanı.

   Yalnızca gösterim: ödeme her zaman TL, B2B fiyat listeleri TL. Bu dosya
   hiçbir fiyatı hesaplamaz; sayfada zaten basılmış TL tutarını (kuruş
   cinsinden `data-hb-money`) seçili kura bölüp metni değiştirir, TL'ye
   dönünce orijinal metni geri koyar.

   Kurlar: shop.metafields.hb_b2b.fx_rates (snippets/hb-fx.liquid sayfaya
   gömer, harici istek yok). Kur tarihi 2 iş gününden eskiyse ya da yoksa
   katman HİÇ çalışmaz: seçici gizli kalır, fiyatlar TL görünür.

   İşaretleme sözleşmesi:
     data-hb-money="123450"   TL tutarının kuruşu. Eleman yalnızca tutarı içermeli.
     data-hb-money-keep       Metin TL KALIR; yaklaşık tutar CSS ::after ile
                              (data-hb-fx-alt) gösterilir. textContent değişmez —
                              sepet toplamı ve CSV'ye okunan hücreler için.
     data-hb-fx-note          "Yaklaşık tutar · TCMB … · Ödeme TL olarak alınır" notu.
     [data-hb-cur-set]        Seçici düğmeleri (TRY | EUR | USD).

   Dinamik yenilemeler (varyant, sepet, hızlı sipariş): sayfa kodu bir
   elemanın metnini yeni TL tutarıyla değiştirirse bu fark edilir, kuruş
   değeri yeni metinden okunur ve tekrar çevrilir (MutationObserver). */
(function () {
  'use strict';

  var R = window.hbFxRates || null;
  var KEY = 'hb_cur';
  var LIST = ['TRY', 'EUR', 'USD'];
  var SYM = { EUR: '€', USD: '$' };
  var de = document.documentElement;

  // Kur bülteninin yaşı, İŞ GÜNÜ olarak (hafta sonu sayılmaz): cuma kuru
  // pazartesi sabahı hâlâ geçerli sayılır; TCMB hafta sonu bülten yayımlamaz.
  function businessDaysSince(iso) {
    var p = String(iso).split('-');
    if (p.length !== 3) return 99;
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (isNaN(d.getTime()) || d > today) return 99;
    var n = 0;
    while (d < today) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n++;
    }
    return n;
  }

  var OK = !!(R && R.USD > 0 && R.EUR > 0 && R.date && businessDaysSince(R.date) <= 2);
  if (!OK) return;                      // seçici CSS ile gizli kalır, fiyatlar TL
  de.classList.add('hb-fx-ok');

  function load() {
    try {
      var v = window.localStorage.getItem(KEY);
      return LIST.indexOf(v) >= 0 ? v : 'TRY';
    } catch (e) {
      return 'TRY';
    }
  }
  function save(v) {
    try { window.localStorage.setItem(KEY, v); } catch (e) { /* gizli sekme: TL'de kalır */ }
  }

  var cur = load();

  function isEn() { return de.getAttribute('data-hb-lang') === 'en'; }

  function fmt(cents, c) {
    var v = cents / 100 / R[c];
    var s = Math.abs(v).toLocaleString(isEn() ? 'en-US' : 'tr-TR',
      { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (v < 0 ? '-' : '') + SYM[c] + s;
  }

  // "1.234,50 TL" / "1.234,50 TRY" / "-12,00 TL" -> kuruş. Bulamazsa null.
  function parseTL(t) {
    var m = String(t || '').match(/(-?)\s*(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d{1,2}))?/);
    if (!m) return null;
    var lira = parseInt(m[2].replace(/\./g, ''), 10);
    var kurus = m[3] ? parseInt((m[3] + '0').slice(0, 2), 10) : 0;
    var v = lira * 100 + kurus;
    return m[1] ? -v : v;
  }

  function dateTxt() {
    var p = R.date.split('-');
    return p[2] + '.' + p[1] + '.' + p[0];
  }
  function noteTxt() {
    return isEn()
      ? 'Approximate amount · CBRT rate of ' + dateTxt() + ' · Payment is taken in TRY'
      : 'Yaklaşık tutar · TCMB ' + dateTxt() + ' kuru · Ödeme TL olarak alınır';
  }

  function one(el) {
    var t = el.textContent;
    if (el.__hbOut == null || t !== el.__hbOut) {
      // Metin sayfa koduna ait (TL). Sonradan değiştiyse kuruşu yeni metinden al.
      if (el.__hbTL !== undefined && t !== el.__hbTL) {
        var p = parseTL(t);
        if (p !== null) el.setAttribute('data-hb-money', String(p));
      }
      el.__hbTL = t;
      el.__hbOut = null;
    }
    var cents = parseInt(el.getAttribute('data-hb-money'), 10);
    var off = cur === 'TRY' || isNaN(cents) || !/\d/.test(el.__hbTL);

    if (el.hasAttribute('data-hb-money-keep')) {
      var alt = off ? '' : '≈ ' + fmt(cents, cur);
      if (alt) {
        if (el.getAttribute('data-hb-fx-alt') !== alt) el.setAttribute('data-hb-fx-alt', alt);
      } else if (el.hasAttribute('data-hb-fx-alt')) {
        el.removeAttribute('data-hb-fx-alt');
      }
      return;
    }
    if (off) {
      if (el.__hbOut != null) {
        el.textContent = el.__hbTL;
        el.__hbOut = null;
      }
      return;
    }
    var out = fmt(cents, cur);
    if (t !== out) el.textContent = out;
    el.__hbOut = out;
  }

  // Açık not yoksa, çevrilmiş tutar içeren her sayfada içeriğin başına bir not.
  function notes() {
    var on = cur !== 'TRY';
    var main = document.querySelector('main') || document.body;
    if (on && main && main.querySelector('[data-hb-money]') && !main.querySelector('[data-hb-fx-note]')) {
      var n = document.createElement('p');
      n.className = 'hb-fx-note hb-fx-note--page';
      n.setAttribute('data-hb-fx-note', 'auto');
      main.insertBefore(n, main.firstChild);
    }
    document.querySelectorAll('[data-hb-fx-note]').forEach(function (n) {
      var txt = noteTxt();
      if (n.textContent !== txt) n.textContent = txt;
      if (n.hidden === on) n.hidden = !on;
    });
  }

  function toggles() {
    document.querySelectorAll('[data-hb-cur-set]').forEach(function (b) {
      var p = String(b.getAttribute('data-hb-cur-set') === cur);
      if (b.getAttribute('aria-pressed') !== p) b.setAttribute('aria-pressed', p);
    });
    document.querySelectorAll('[data-hb-fx-toggle]').forEach(function (g) {
      var tip = cur === 'TRY' ? '' : noteTxt();
      if (g.getAttribute('title') !== tip) g.setAttribute('title', tip);
    });
    de.classList.toggle('hb-fx-active', cur !== 'TRY');
  }

  var pending = false;
  function run() {
    pending = false;
    document.querySelectorAll('[data-hb-money]').forEach(one);
    notes();
    toggles();
  }
  // rAF arka plan sekmesinde durur (sepet/varyant yenilemesi o sırada olursa
  // çeviri sekmeye dönülene kadar beklerdi); setTimeout yedeği hangisi önce
  // gelirse onu çalıştırır.
  function schedule() {
    if (pending) return;
    pending = true;
    var done = false;
    var go = function () {
      if (done) return;
      done = true;
      run();
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(go);
    setTimeout(go, 120);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hb-cur-set]');
    if (!b) return;
    var v = b.getAttribute('data-hb-cur-set');
    if (LIST.indexOf(v) < 0) return;
    cur = v;
    save(v);
    run();
  });

  // Başka sekmede seçim değişirse burada da uygula.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { cur = load(); run(); }
  });

  // Varyant/sepet/hızlı sipariş yenilemeleri ve TR/EN değişimi.
  new MutationObserver(schedule).observe(de, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['data-hb-money', 'data-hb-lang']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Test ve hata ayıklama için salt-okuma bilgi.
  window.hbFx = {
    get currency() { return cur; },
    rates: R,
    parseTL: parseTL,
    format: fmt
  };
})();
